<template>
  <div>
    <AppNavDesktop />

    <div class="content-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
export default {

  components: {
    AppNavDesktop: () => import('@/components/layout/nav/AppNavDesktop'),
  },

  data() {
    return {
      route: {
        name: 'test',
      },
    };
  },
};
</script>
